import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import CircularProgress from '@material-ui/core/CircularProgress'
import BkFlowRoomEnhancementButton from './BkFlowRoomEnhancementButton'
import getCurrencySymbol from '../../utilities/currency/getCurrencySymbol'

// Import activeStep actions
import setActiveStep from '../../actions/activeStepActions'
import modifyPostEnhancements from '../../actions/modifyPostEnhancementsActions'

import '../../styles/css/base/modal.css'
import '../../styles/css/components/enhancements/bk-flow-enhancements.css'

import _ from 'lodash'

class BkFlowPostEnhancements extends Component {

	constructor(props) {
		super(props)
		let initEnhancements = props.activeEnhancementData

		this.state = {
			modalIsOpen: true,
			initialEnhancements: initEnhancements
		}

		this.openModal = this.openModal.bind(this)
		this.closeModal = this.closeModal.bind(this)
	}

	openModal() {
		this.setState({modalIsOpen: true})
	}

	closeModal() {
		const { activeStep, handleEnhancementsClose } = this.props
		let updatedStep = activeStep + 1

		this.setState({modalIsOpen: false})
		handleEnhancementsClose(updatedStep)
	}

	// Construct enhancements cards
	renderEnhancementsBody() {
		const { configData, enhancementData, activeRoom, reservationData } = this.props
		const hotelLabels = configData.hotel.labels[0]

		function renderEnhancementCards() {
			let enhancementGroups = []

			for (let roomGroupKey in activeRoom) {
				const enhancementCardType = enhancementData.enhancements[activeRoom[roomGroupKey][0][0].roomTypeCode],
							currencyCode = activeRoom[roomGroupKey][1][0].rates[0].base.currencyCode,
							currencySymbol = getCurrencySymbol(currencyCode)

				let enhancementCards = []

				for (let enhancementKey in enhancementCardType) {
					const enhancementDetailsData = enhancementCardType[enhancementKey].serviceDetails.comments

					// Loop and re-key enhancement details
					let keyedDetails = {},
							renderEnhancementImage = '',
							renderEnhancementTitle = '',
							renderEnhancementDescription = null,
							renderEnhancementPrice = null

					for (let detailKey in enhancementDetailsData){
						keyedDetails[enhancementDetailsData[detailKey].name.toLowerCase()] = enhancementDetailsData[detailKey]
					}

					// Init image or placeholder
					if (keyedDetails.image) {
						renderEnhancementImage = <div className="bk-flow-enhancements__card-image u-bg-image" style={{backgroundImage: 'url(' + keyedDetails.image.image + ')'}}><img className="u-element-hidden" src={keyedDetails.image.image} alt="Coming Soon" /></div>
					} else {
						renderEnhancementImage = <div className="bk-flow-enhancements__card-image u-bg-image" style={{backgroundImage: 'url(https://placeimg.com/640/398/nature)'}}><img className="u-element-hidden" src="https://placeimg.com/640/398/nature" alt="Coming Soon" /></div>
					}

					// Init title or placeholder
					if (keyedDetails.title) {
						renderEnhancementTitle = <h5>{keyedDetails.title.text}</h5>
					} else {
						renderEnhancementTitle = <h5>{ hotelLabels.offer }: {enhancementCardType[enhancementKey].serviceInventoryCode}</h5>
					}

					// Init description
					if (enhancementCardType[enhancementKey].price[0].base.amountAfterTax) {
						renderEnhancementPrice = <p className="bk-flow-enhancements__card-price u-remove-margin u-font-bold">{ currencySymbol }{ enhancementCardType[enhancementKey].price[0].base.amountAfterTax} { currencyCode }/{enhancementCardType[enhancementKey].servicePricingType}</p>
					}

					// Init description
					if (keyedDetails.description) {
						renderEnhancementDescription = <p>{keyedDetails.description.text}</p>
					}

					// Construct card with details
					enhancementCards.push(
						<div className="bk-flow-enhancements__card" key={enhancementCardType[enhancementKey].serviceInventoryCode + '-' + enhancementKey}>
							{renderEnhancementImage}
							<div className="bk-flow-enhancements__card-data">
								{renderEnhancementTitle}
								{renderEnhancementDescription}
								{renderEnhancementPrice}
								<BkFlowRoomEnhancementButton
									enhancementKey={enhancementCardType[enhancementKey].serviceInventoryCode + '-' + activeRoom[roomGroupKey][0][0].roomTypeCode + '-' + roomGroupKey}
									enhancementApiData={enhancementCardType[enhancementKey]}
									roomGroup={roomGroupKey}
									roomType={activeRoom[roomGroupKey][0][0].roomTypeCode}
								/>
							</div>
						</div>
					)
				}

				// Construct enhancement groups with title & cards
				enhancementGroups.push(
					<div key={roomGroupKey} className="bk-flow-enhancements__group row center-sm between-xs">
						<div className="bk-flow-enhancements__heading u-flex u-flex--justify-center">
							<h4>{'Upgrade ' + activeRoom[roomGroupKey][0][0].roomDescription.name}</h4>
						</div>
						{enhancementCards}
					</div>
				)
			}

			// Render all enhancement groups
			return enhancementGroups
		}

		return  (
			<div className="bk-flow-enhancements__modal">
				{ enhancementData.loading || reservationData.loading ?
					<div className="bk-flow-enhancements__loading"><CircularProgress size={50} className="bk-flow-enhancements__loading" /></div>
				:
					<div className="bk-flow-enhancements__cards">{renderEnhancementCards()}</div>
				}
			</div>
		)
	}

	render() {
		const { configData, urlData, activeRoom, activeEnhancementData, activeGuest, activePayment, activeCreditType, reservationData, submitModifyReservation } = this.props
		let previousEnhancements = this.state.initialEnhancements
		const hotelLabels = configData.hotel.labels[0]

		return (
			<div className="bk-flow-enhancements__content">
				<Modal
					className={{
						base: 'u-modal',
						afterOpen: 'u-modal--visible',
						beforeClose: 'u-modal--close',
						ariaHideApp: false
					}}
          overlayClassName={{
            base: 'u-fade',
            afterOpen: 'u-fade--visible',
            beforeClose: 'u-fade--visible'
          }}
					isOpen={this.state.modalIsOpen}
					onRequestClose={this.closeModal}
					contentLabel="Enhancements Modal"
					shouldCloseOnOverlayClick={false}
					ariaHideApp={false}
				>

					<div className="u-modal__header u-bg-medium-grey row middle-xs">
						<h2 className="u-remove-margin">{ hotelLabels.enhanceYourStay }</h2>
						{ _.isEqual(activeEnhancementData, previousEnhancements) || reservationData.loading || reservationData.confirmation.hotelResModifies ?
							null
						:
							<button
								className="u-modal__update btn btn-red"
								onClick={() => submitModifyReservation(urlData, activeRoom, activeEnhancementData, activeGuest, activePayment, activeCreditType, reservationData)}
							>
								{ hotelLabels.updateReservation }
							</button>
						}
							<button
								className="u-modal__close btn btn-primary"
								onClick={this.closeModal}
							>
								{ hotelLabels.close } &times;
							</button>
					</div>

					<div className="u-modal__body">
						<div className="bk-flow-enhancements row">

							{ reservationData.error ?
								<div className="bk-flow-room__errors">
									<h5 className="u-remove-margin">{ hotelLabels.errorFetchingServices }</h5>
									<p className="u-remove-margin">{reservationData.error.message}</p>
								</div>
							:
								null
							}

							{ reservationData.confirmation.hotelResModifies ?
								<div>
									<h5 className="u-remove-margin">Success!</h5>
									<p>{ hotelLabels.reservationUpdateSuccess }.</p>
									<button
										className="btn btn-primary"
										onClick={this.closeModal}
									>
										{ hotelLabels.viewConfirmation }
									</button>
								</div>
							:
								this.renderEnhancementsBody()
							}

						</div>
					</div>

				</Modal>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		urlData: state.availabilityData.urlData,
		enhancementData: state.enhancementData,
		activeRoom: state.activeRoomData,
		activeEnhancementData: state.activeEnhancementData,
		activeStep: state.activeStepData.activeStep,
		activeGuest: state.form.guestForm,
		activePayment: state.form.paymentForm,
		activeCreditType: state.activeCreditData.creditType,
		reservationData: state.reservationData
	}
}

const mapDispatchToProps = dispatch => ({
	submitModifyReservation(urlData, activeRoom, activeEnhancementData, activeGuest, activePayment, activeCreditType, reservationData) {

		// Dispatch reservation submission to createReservation action
		return (
			dispatch(modifyPostEnhancements(urlData, activeRoom, activeEnhancementData, activeGuest, activePayment, activeCreditType, reservationData))
		)
	},
	handleEnhancementsClose(updatedStep) {
		// Dispatch step update
		return (
			dispatch(setActiveStep(updatedStep))
		)
	}
})


export default connect(mapStateToProps, mapDispatchToProps)(BkFlowPostEnhancements)


// WEBPACK FOOTER //
// ./src/components/enhancements/BkFlowPostEnhancements.js